import React from 'react';

const PaymentWaitStep = (props) => {
    // todo: periodically check an API endpoint for checkout status
    console.log('PaymentWaitStep');

    return (
        <div>The PAYMENT_WAIT status</div>
    );
};

export default PaymentWaitStep;
